import React, { useContext } from "react";

import { observer } from "mobx-react";
import { readableColor } from "polished";
import PropTypes from "prop-types";
import styled, { ThemeContext } from "styled-components";

import { useStores } from "../../../../contexts/StoreContext";
import Icon from "../../../Icon/Icon";
import useDevice from "../../../customHooks/useDevice";
import LocationSelect from "../../LocationSelect/LocationSelect";

const StyledContainer = styled.div`
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
  max-height: ${(props) => (props.isHidden ? "0" : "100px")};
  overflow: hidden;
`;

const StyledHeader = styled.div`
  padding: 6px 15px;
  margin-bottom: 15px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  h5 {
    margin-bottom: 0px;
  }

  svg {
    cursor: pointer;
  }
`;

const StyledFilterWrapper = styled.div`
  background-color: ${({ isMobile, theme }) =>
    isMobile
      ? theme.primaryBackgroundColor
      : readableColor(
          theme.primaryBackgroundColor,
          theme.textColor,
          theme.negativeTextColor,
          false
        )};
  color: ${({ isMobile, theme }) =>
    isMobile
      ? readableColor(
          theme.primaryBackgroundColor,
          theme.textColor,
          theme.negativeTextColor,
          false
        )
      : theme.primaryBackgroundColor};
`;

function CountryFilter(props) {
  const { search, initialValue } = props;
  const theme = useContext(ThemeContext);
  const { filtersStore } = useStores();
  const { isSmallScreen, isMobile } = useDevice();

  const { setFilter, filters } = filtersStore;
  const [hide, setHide] = React.useState(false);

  const handleLocationSelect = (selectedLocation) => {
    if (!selectedLocation && !filters.location) {
      return;
    }

    setFilter("locationLabel", null);

    if (selectedLocation?.coordsMode) {
      const locationObject = {
        coords: { lat: selectedLocation?.lat, lng: selectedLocation?.long },
        label: selectedLocation?.label,
        value: selectedLocation?.value,
      };

      setFilter("location", selectedLocation ? locationObject : null);
      search();
    } else {
      setFilter(
        "locationLabel",
        selectedLocation ? selectedLocation.city : null
      );
      if (!selectedLocation?.location) {
        setFilter("location", null);
      }
      search();
    }
  };

  return (
    <StyledFilterWrapper className="p-3" isMobile={isMobile || isSmallScreen}>
      <StyledHeader className="d-flex justify-content-between">
        <h5>Location</h5>
        <div
          onClick={() => {
            setHide(!hide);
          }}
        >
          <Icon
            color={
              isMobile || isSmallScreen
                ? readableColor(
                    theme.primaryBackgroundColor,
                    theme.textColor,
                    theme.negativeTextColor,
                    false
                  )
                : theme.primaryBackgroundColor
            }
            icon={hide ? "chevronUp" : "chevronDown"}
            size={16}
          />
        </div>
      </StyledHeader>
      <StyledContainer isHidden={hide}>
        <LocationSelect
          initialValue={initialValue["location[label]"]}
          onSelect={(a) => handleLocationSelect(a)}
          placeholder="Location..."
        />
      </StyledContainer>
    </StyledFilterWrapper>
  );
}
export default observer(CountryFilter);

CountryFilter.propTypes = {
  initialValue: PropTypes.shape({}),
  search: PropTypes.func,
};

CountryFilter.defaultProps = {
  initialValue: {},
  search: () => {},
};
